export default {
  brands: [],
  loader: true,
  lines: [],
  sublines: [],
  products: {data:[]},
  groups: [],
  categories: [],
  subbrands: [],
  error: false,
  errorMessage: "",
	contactsWarehouses:[],
  type_user:"",
  params: {
    filter_lines: [],
    filter_sublines: [],
    filter_brands: [],
    filter_subbrands: [],
    filter_groups: [],
    filter_categories: [],
    paginate: true,
    page: 1,
    filter: "",
    reference: "",
    warehouse: 0,
    only_promotions: false,
    clasification: "",
    role_user: "",
    only_lines_unlocked_b2b: 1,
    with_stock: false,
    sortBy: null,
    sort: null,
    // Filtros vehiculos
    vehicle_brand_id: null,
    vehicle_model_id: null,
    vehicle_year_id: null,
    vehicle_engine_displacement_id: null,
    vehicle_transmission_id: null
  },
  category_params: {
    filter_brands: [],
    filter_groups: [],
    lines: ""
  },
  promotions: [],
  selectedProduct: [],
  selectedPromotion: null,
  productsFiltered: [],
  showPromotionsModal: false,
  minimumPriceProducts: [],
  labelButtonPromotion: "Aplicar Promoción",
  branchOfficesWarehousesAvailableProduct: {
    product: null,
    branchOfficesAvailable: [],
    previous_product_id: null
  },
  date_of_fetch:null,
  selectedProductItem: {
    total:0,
    quantity_available:'',
    long_description:'',
    code:'',
    cant:null,
    click:0,
    brand:{},
    category:{},
    line:{},
    products_attachments:[],
    subline:{},
    price:{}
  }
};



// WEBPACK FOOTER //
// ./src/b2b/modules/catalog/state.js